import { colors } from './colors'

export const borders = {
  card: `1px solid ${colors.colorA3}`,
  outlineButton: `1px solid ${colors.colorA2}`,
  outlineBlueButton: `1px solid ${colors.colorA4}`,
}
